export default "__VITE_ASSET__bea83a9f__"